module.exports = __webpack_public_path__ + "static/img/产品体验中心.fb01e353.png";